import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { translationKeyForPartnerMemberPermissionLabel } from '../../../utils';
import { CellRendererParams } from './types';

export const PermissionRenderer: FC<CellRendererParams> = ({ data }) => {
  return data.permissionSetType ? (
    <FormattedMessage
      id={translationKeyForPartnerMemberPermissionLabel(data.permissionSetType)}
    />
  ) : (
    <></>
  );
};
